import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { IndexAllocation as OldIndexAllocation } from "@models/tradable/index-allocation";

export interface IndexAllocation {
	readonly assetId: number;
	readonly balance: number;
	readonly allocation: string;
	readonly allocationPercentage: string;
}

export class IndexAllocationAdapter extends BaseAdapter<OldIndexAllocation, IndexAllocation> {
	public adapt(item: OldIndexAllocation): IndexAllocation {
		if (!item) {
			return null;
		}

		return {
			assetId: Number(item.getAssetId()),
			balance: Number(item.getBalance()),
			allocation: item.getAllocation(),
			allocationPercentage: item.getAllocationPercent()
		};
	}
}
